module.exports = __webpack_public_path__ + "static/media/no-access.3aea8f92.png";